/*
*###############################################################################
*Module Name                   : DPPermission.js                               #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  Minol Prageesha                              #
*Date                          : Friday, October 29th 2021, 11:08:32 am        #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, Button, Container, img, CardText, Alert } from "reactstrap"

// import images

import Logo from "assets/images/logo/Logo.png"

//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert"
// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"
import DPTextBox from 'framework/components/DPTextBox';
import { Text } from 'framework/validators/TextValidation';
import DPButton from './DPButton';

const DPPasswordReset = ({ confirm_both, title, onConfirm, accept, onCancel, onReset, showCancel,
    btnColor, cancelColor, btnYes, btnNo, reset, resetColor, confirmPasswordOnChange, confirmPassword,
    newPasswordOnchange, newPassword, code, name, reason, reasonOnChange, show, AlertColor, AlertMsg, ErrorMsg }) => {

    let htmlTitle = <h3 style={{ color: "#2A3042" }}>{title}</h3>

    return (
        <div>
            {confirm_both ? (
                <SweetAlert
                    title={""}
                    custom
                    style={{width:"800"}}
                    customIcon={""}
                    showCancel={showCancel}
                    confirmBtnBsStyle={btnColor}
                    cancelBtnBsStyle={cancelColor}
                    onConfirm={onConfirm}
                    onCancel={onCancel}
                    customButtons={
                        <Row>
                            <Row>
                                <Col>
                                    <DPButton
                                        size={'md'}
                                        text={"Accept"}
                                        width={"lg"}
                                        onClick={accept}
                                        color={btnColor}
                                    />

                                </Col>
                                <Col>
                                    <DPButton
                                        size={'md'}
                                        text={"Cancel"}
                                        width={"lg"}
                                        onClick={onCancel}
                                        color={cancelColor}
                                    />
                                    {/* <Button color={cancelColor} size="md" onClick={onCancel} >{btnNo ? btnNo : 'Cancel'}</Button> */}
                                </Col>

                            </Row>
                            <Row>
                               {' '}
                            <hr ></hr>
                            </Row>
                            
                            <Row>
                                
                          
                                <Col>
                                    <DPButton
                                        size={'md'}
                                        text={"Reset SSO"}
                                        width={"lg"}
                                        onClick={onReset}
                                        color={resetColor}
                                    />
                                    {/* <Button color={resetColor} size="md" onClick={onReset} >{reset ? reset : `Reset`}</Button> */}
                                </Col>
                            </Row>
                        </Row>
                    } >
                    <React.Fragment>
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col sm="12" >
                                                <Row>
                                                    {htmlTitle}
                                                </Row>

                                            </Col>
                                        </Row>

                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="4" >
                                <Row >
                                </Row>
                            </Col>
                            <Col sm="4" >
                                <img
                                    src={Logo}
                                    alt=""
                                    className=""
                                    height="30"
                                />
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={12} className="mb-4-sm">
                                <Row >
                                    <Col sm={12} md={3} className="mb-4-sm">
                                        <label style={{ textAlign: "left" }}> Code  </label>

                                    </Col>
                                    <Col sm={12} md={9} className="mb-4-sm" style={{ textAlign: "left" }}>

                                        <label style={{ textAlign: "left" }}> {code} </label>
                                    </Col>


                                </Row>
                                <Row >
                                    <Col sm={12} md={3} className="mb-4-sm">
                                        <label> Name  </label>

                                    </Col>

                                    <Col sm={12} md={9} className="mb-4-sm" style={{ textAlign: "left" }}>
                                        <label > {name} </label>
                                    </Col>

                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <CardText className="mb-0">
                                    <Row>
                                        <Col sm={12} md={12} className="mb-4-sm">
                                            <DPTextBox
                                                rowClass="mb-4-sm"
                                                labelText="New Password"
                                                textType="password"
                                                maxLength="20"
                                                value={newPassword}
                                                onChange={newPasswordOnchange}
                                            />
                                            <DPTextBox
                                                rowClass="mb-4-sm"
                                                labelText="Confirm Password"
                                                textType="password"
                                                maxLength="20"
                                                value={confirmPassword}
                                                onChange={confirmPasswordOnChange}
                                            />
                                            <DPTextBox
                                                rowClass="mb-4-sm"
                                                labelText="Reason"
                                                textType="text"
                                                maxLength="50"
                                                value={reason}
                                                onChange={reasonOnChange}
                                            />
                                        </Col>
                                    </Row>
                                </CardText>
                            </Col>
                        </Row>
                    </React.Fragment>

                </SweetAlert>
            ) : null}
        </div>
    );
}
export default DPPasswordReset;